const envio_inventario = state => state.envio_inventario;

export default {
  envio_inventario,
};